/** @format */

import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';

import Loading from '../Loading';
import TopSection from '../TopSection/TopSection';

function Payment() {
	const [t] = useTranslation('translation');

	const data = useStoreState((state) => state.payment);
	const service = useStoreActions((actions) => actions.payment);
	const bookingData = useStoreState((state) => state.cart);

	useEffect(() => {
		let bookingRequest = {
			contactPerson: bookingData.contactPerson,
		};

		if (bookingData.travelOut != null) {
			bookingRequest.travelOut = (({
				departure,
				stopIdDeparture,
				stopIdArrival,
				tripId,
				routeShortName,
				arrival,
				pbe,
				article,
			}) => ({
				departure,
				stopIdDeparture,
				stopIdArrival,
				tripId,
				routeShortName,
				arrival,
				pbe,
				article,
			}))(bookingData.travelOut);
		}
		service.createBooking({ ...bookingRequest });
		// eslint-disable-next-line
	}, []);

	if (data.error !== null) return <Redirect to={{ pathname: '/Error' }} />;

	if (data.ResultUrl !== null) {
		return <Redirect to={{ pathname: data.ResultUrl }} />;
	}

	return (
		<div>
			<section>
				<TopSection />
			</section>
			<section style={{ paddingTop: '22rem' }}>
				<h1>{t('pleaseWait')}</h1>
				<Loading />
			</section>
		</div>
	);
}

export default Payment;
